import StepTwo from "@/components/dashboard/buyCrypto/StepTwo";

export default function BuyCryptoTwo() {
  return <StepTwo />;
}
